import { APIFactory } from '../api/api.factory'
const ExpenseReportAPI = APIFactory.get('expenseReport')

export default {
    async getExpenseReportSubmission(erID) {
        const { data } = await ExpenseReportAPI.getExpenseReportSubmission(erID)
        return data;
    },
    async getSummaryCosts(erID) {
        const { data } = await ExpenseReportAPI.getSummaryCosts(erID)
        return data;
    }
}